import { Skeleton } from 'antd';
import * as React from 'react';

import s from './SkeletonRow.module.scss';

type SkeletonRowProps = {
  columnsCount: number;
  firstColumnWidth: number;
  totalWidth: number;
  rowHeight: number;
  style?: React.CSSProperties;
  isFixedColumn?: boolean;
};

/** Skeleton-строка для отображения во время загрузки */
const SkeletonRow: React.FC<SkeletonRowProps> = ({
  columnsCount,
  firstColumnWidth,
  totalWidth,
  rowHeight,
  style,
  isFixedColumn = false,
}) => {
  if (isFixedColumn) {
    return (
      <div className={s.skeletonRowOuter} style={style}>
        <div
          className={s.skeletonFixedCell}
          style={{
            width: firstColumnWidth,
            minWidth: firstColumnWidth,
            height: rowHeight,
          }}
        >
          <Skeleton.Input active size="small" className={s.skeletonInput} />
        </div>
      </div>
    );
  }

  return (
    <div className={s.skeletonRowOuter} style={style}>
      <div
        className={s.skeletonRow}
        style={{ width: totalWidth - firstColumnWidth }}
      >
        {Array.from({ length: columnsCount - 1 }).map((_, index) => (
          <div key={index} className={s.skeletonCell}>
            <Skeleton.Input active size="small" className={s.skeletonInput} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(SkeletonRow);
